import React from 'react';
import { InstagramIcon, LinkedinIcon, GithubIcon, TwitterIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function SocialLinks() {
  return <div className="flex flex-wrap gap-4" data-id="element-137">
      <a href="https://www.instagram.com/hustle.with.sai/" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" aria-label="Instagram" data-id="element-138">
        <InstagramIcon size={20} data-id="element-139" />
      </a>
      <a href="https://www.linkedin.com/in/sai-akhil-madurakavi" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" aria-label="LinkedIn" data-id="element-140">
        <LinkedinIcon size={20} data-id="element-141" />
      </a>
      <a href="https://github.com/SaiAkhilM" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" aria-label="GitHub" data-id="element-142">
        <GithubIcon size={20} data-id="element-143" />
      </a>
      <a href="https://x.com/Sai_Akhil_M" target="_blank" rel="noopener noreferrer" className="text-text-secondary hover:text-primary transition-colors" aria-label="Twitter" data-id="element-144">
        <TwitterIcon size={20} data-id="element-145" />
      </a>
      <a href="mailto:akhisai2526@gmail.com" className="text-text-secondary hover:text-primary transition-colors" aria-label="Email" data-id="element-146"></a>
      <a href="tel:6692724954" className="text-text-secondary hover:text-primary transition-colors" aria-label="Phone" data-id="element-147"></a>
    </div>;
}